"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListSync = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _lodash = require("lodash");

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.error"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.loading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ListSync = /*#__PURE__*/function (_Component) {
  _inherits(ListSync, _Component);

  var _super = _createSuper(ListSync);

  function ListSync(props) {
    var _this;

    _classCallCheck(this, ListSync);

    _this = _super.call(this, props);
    _this.requestUpdateList = (0, _lodash.debounce)(function () {
      return _this.updateList();
    }, 500);
    _this.scrollNode = undefined;
    return _this;
  }

  _createClass(ListSync, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          loadOnScroll = _this$props.loadOnScroll,
          pageSize = _this$props.pageSize,
          setFilters = _this$props.setFilters,
          actionType = _this$props.actionType;

      if (pageSize) {
        setFilters({
          pageSize: pageSize
        }, actionType);
      }

      this.getScrollNode();

      if (loadOnScroll && this.scrollNode) {
        this.initLoadOnScroll();
      }

      this.fetchData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.fetchData();

      if (prevProps.container !== this.props.container) {
        this.getScrollNode();
        this.initLoadOnScroll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearScroll();
    }
  }, {
    key: "getScrollNode",
    value: function getScrollNode() {
      var scrollNode = null; // container being null means the variable is set but the container is not yet available

      if (this.props.container !== null) {
        // we do nothing if it's null
        // container being undefined means the variable wasn't set so we're listening to the window
        if (typeof this.props.container === 'undefined') {
          scrollNode = window;
        } // container being defined means we need to listen to it instead


        if (this.props.container) {
          scrollNode = this.props.container;
        }
      }

      this.scrollNode = scrollNode;
    }
  }, {
    key: "initLoadOnScroll",
    value: function initLoadOnScroll() {
      if (this.scrollNode) {
        this.scrollNode.removeEventListener('scroll', this.requestUpdateList, false);
        this.scrollNode.addEventListener('scroll', this.requestUpdateList, false);
      }
    }
  }, {
    key: "clearScroll",
    value: function clearScroll() {
      if (this.scrollNode) {
        window.removeEventListener('scroll', this.requestUpdateList, false);
      }
    }
  }, {
    key: "updateList",
    value: function updateList() {
      var _this$props2 = this.props,
          _this$props2$listStor = _this$props2.listStore,
          fetching = _this$props2$listStor.fetching,
          pagination = _this$props2$listStor.pagination,
          setFilters = _this$props2.setFilters,
          actionType = _this$props2.actionType;
      var y = this.scrollNode === window ? window.pageYOffset : this.scrollNode.scrollTop;
      var closeToBottom;

      if (this.scrollNode === window) {
        closeToBottom = document.documentElement.scrollHeight - window.outerHeight - y < 1500;
      } else {
        closeToBottom = this.scrollNode.scrollHeight - y - this.scrollNode.clientHeight < 500;
      }

      var current = pagination.current,
          max = pagination.max;

      if (current && max && y > 0 && closeToBottom) {
        var isMax = current === max;

        if (!fetching && !isMax) {
          setFilters({
            pageNum: current + 1
          }, actionType);
        }
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this$props3 = this.props,
          _this$props3$listStor = _this$props3.listStore,
          shouldFetch = _this$props3$listStor.shouldFetch,
          clear = _this$props3$listStor.clear,
          fetch = _this$props3.fetch;

      if (shouldFetch && fetch) {
        if (this.request) this.request.abort();
        this.request = fetch(clear);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          listStore = _this$props4.listStore,
          fetch = _this$props4.fetch,
          filterCondition = _this$props4.filterCondition,
          loadingPlaceholders = _this$props4.loadingPlaceholders;
      var fetched = listStore.fetched,
          fetching = listStore.fetching,
          status = listStore.status,
          data = listStore.data;
      var noData = fetched && data.length === 0 && status === 'success';
      var error = fetched && (status === 'error' || status === 'not found');
      var ListElement = children.type;
      var renderedData = [];

      if (process.env === 'development') {
        if (!listStore) {
          console.warn('You need to pass the store in the listStore prop');
          return null;
        }

        if (children.length > 1) {
          console.warn('ListSync should only have one child, a Row');
          return null;
        }
      }

      var filteredData = data.filter(function (element) {
        return filterCondition(element);
      });

      if (data && data.length) {
        renderedData = filteredData.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement(ListElement, _extends({
            data: item,
            key: "".concat(ListElement.name, "_").concat(index)
          }, children.props));
        });
      }

      if (!fetching && data && data.length || fetching && loadingPlaceholders) {
        var placeholderArr = loadingPlaceholders && fetching ? Array.from(Array(loadingPlaceholders)) : [];

        var loading = function loading(idx) {
          return fetching && loadingPlaceholders && idx >= filteredData.length;
        };

        renderedData = [].concat(_toConsumableArray(filteredData), _toConsumableArray(placeholderArr)).map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var index = arguments.length > 1 ? arguments[1] : undefined;
          return /*#__PURE__*/_react["default"].createElement(ListElement, _extends({
            data: item,
            placeholderLoading: loading(index),
            key: "".concat(ListElement.name, "_").concat(index)
          }, children.props));
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderedData, noData && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
        noData: true
      }), fetching && !loadingPlaceholders && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], null), error && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
        fetchError: true,
        reload: function reload() {
          return fetch(true);
        }
      }));
    }
  }]);

  return ListSync;
}(_react.Component);

exports.ListSync = ListSync;
ListSync.defaultProps = {
  listStore: {
    data: [],
    fetched: false,
    fetching: false,
    status: null,
    filters: {}
  },
  filterCondition: function filterCondition() {
    return true;
  }
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFilters: function setFilters(filters, type) {
      return dispatch({
        type: type,
        filters: filters
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ListSync);

exports["default"] = _default;

//# sourceMappingURL=ListSync.js.map